import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Layout from './Layout';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Portfolio from './pages/Portfolio';
import Pesq from './pages/Pesq';
import Contato from './pages/Contato';
import Blog from './pages/Blog';
import Pessoas from './pages/Pessoas';
import ProducionesArt from './pages/ProducionesArt';
import Softwares from './pages/Softwares';
import Projetos from './pages/Projetos';
import Dissertacoes from './pages/Dissertacoes';
import Teses from './pages/Teses';
import Eventos from './pages/Eventos';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
            <Route>
              <Route path="/" element={<Layout />} />
              <Route path="about" element={<About />} />
              <Route path="contato" element={<Contato />} />
              <Route path="portfolio" element={<Portfolio />} />
              <Route path="pesq" element={<Pesq />} />
              <Route path="blog" element={<Blog />} />
              <Route path="pessoas" element={<Pessoas />} />
              <Route path="produciones_art" element={<ProducionesArt />} />
              <Route path="software" element={<Softwares />} />
              <Route path="projetos" element={<Projetos />} />
              <Route path="dissertacoes" element={<Dissertacoes />} />
              <Route path="teses" element={<Teses />} />
              <Route path="eventos" element={<Eventos />} />
            </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
